import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types.ts';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import {
	KycWorkflowCustomDetailResponseDto,
	UpdateKycWorkflowCustomDetailDto,
} from '@dealstack/shared/lib/generated';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';

export const getKycWorkflowCustomFields = async (
	kycWorkflowId: string,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: KycWorkflowCustomDetailResponseDto[] }>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_CUSTOM_DETAIL_KYCWORKFLOW_KYCWORKFLOWID_GET, {
				kycWorkflowId,
			}),
			method: HTTP_METHOD.GET,
		},
		{
			...options,
		}
	);
};

export const updateKycWorkflowCustomField = async (
	kycWorkflowId: string,
	data: UpdateKycWorkflowCustomDetailDto,
	options?: ServiceRequestOptions
) => {
	return await makeRequest<{ payload: unknown }>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_CUSTOM_DETAIL_KYCWORKFLOW_KYCWORKFLOWID_PUT, {
				kycWorkflowId,
			}),
			method: HTTP_METHOD.PUT,
			body: JSON.stringify(data),
		},
		{
			...options,
		}
	);
};
